import { useLocation } from 'react-router-dom';
import { Link, Tab, TabList, Tabs } from '@spotted-zebra-uk/ui-components';
import styles from './SubNavigation.module.scss';

type SubNavigationProps = {
  config: {
    title: string;
    path: string;
  }[];
};

export function SubNavigation({ config }: SubNavigationProps) {
  const location = useLocation();
  const selectedTabIndex = config.findIndex(config =>
    config.path.includes(location.pathname)
  );

  return (
    <Tabs className={styles.subNavigation} selectedTabIndex={selectedTabIndex}>
      <TabList>
        {config.map(({ title, path }) => (
          <Tab key={title} className={styles.subNavigationTab}>
            <Link className={styles.tabLink} to={path}>
              {title}
            </Link>
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}
